let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kkylz")).then(() => parcelRequire('jnYmb'));